var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('PageLoader'),(!_vm.$route.meta.hideNavbarAndFooter)?_c('Navigation'):_vm._e(),_c('router-view'),(!_vm.$route.meta.hideNavbarAndFooter)?_c('FooterComponent'):_vm._e(),_c('ScrollToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }